import React from 'react';
import { CONTACT_EMAILS, DEFAULT_CONTACT_EMAIL } from '@/constants/contact';

export interface EmailLinkProps {
  /** Email address to link to */
  email?: string;
  /** CSS class name for the link */
  className?: string;
  /** Children to render inside the link (defaults to email address) */
  children?: React.ReactNode;
}

/**
 * Creates a React component for an email link that can be used as a Tolgee parameter
 *
 * @example
 * ```tsx
 * <T
 *   keyName="some.translation.key"
 *   params={{
 *     email: createEmailLink({ email: CONTACT_EMAILS.SUPPORT }),
 *   }}
 * />
 * ```
 */
export const createEmailLink = ({
  email = DEFAULT_CONTACT_EMAIL,
  className = 'text-ds-text-inverse-4',
  children,
}: EmailLinkProps = {}): React.ReactElement => {
  return (
    <a className={className} href={`mailto:${email}`}>
      {children || email}
    </a>
  );
};

/**
 * Pre-configured email link components for common use cases
 */
export const EmailLinks = {
  /** Support email link */
  support: (className?: string) => createEmailLink({ email: CONTACT_EMAILS.SUPPORT, className }),
  /** Ginione email link */
  ginione: (className?: string) =>
    createEmailLink({ email: CONTACT_EMAILS.GINIONE_SUPPORT, className }),
};
